j = jQuery.noConflict();

/*========== JS Cookie ==========*/

function setCookie(name, value, expiration)
{
	if(expiration === 0)
	{
		document.cookie = name + '=' + value + ';expires=0;path=/;domain=.fourth.com';
	}
	else
	{
		const d = new Date();
		d.setTime(d.getTime() + (expiration * 24 * 60 * 60 * 1000));
		let expires = 'expires=' + d.toUTCString();
		document.cookie = name + '=' + value + ';' + expires + ';path=/;domain=.fourth.com';
	}
}

/*========== Solution for Pagespeed's "Passive Listeners" complaint ==========*/

jQuery.event.special.touchstart = {
    setup: function( _, ns, handle)
    {
        this.addEventListener('touchstart', handle, {passive: !ns.includes('noPreventDefault')});
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle)
    {
        this.addEventListener('touchmove', handle, {passive: !ns.includes('noPreventDefault')});
        //this.addEventListener('touchmove', function (event) { event.preventDefault (); }, {passive: false});
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle){
        this.addEventListener('wheel', handle, {passive: false});
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle)
    {
        this.addEventListener('mousewheel', handle, {passive: false});
    }
};

/*========== Preload full size images ==========*/

if(j('.bg-lazy').length)
{
	j('.bg-lazy').each(function()
	{
		var background_full = j(this).data('background-full');
		j('head').append('<link rel="preload" href="'+background_full+'" as="image">');
	});
}
if(j('.img-lazy').length)
{
	j('.img-lazy').each(function()
	{
		var image_full = j(this).data('image-full');
		j('head').append('<link rel="preload" href="'+image_full+'" as="image">');
	});
}

/*========== Run when ALL resources have loaded ==========*/

window.addEventListener('load', function()
{

// 	if(j('#twspan').length)
// 	{
// 		var app = document.getElementById('twspan');
//
// 		var typewriter = new Typewriter(app, {
// 			loop: false,
// 			cursor: null
// 		});
//
// 		typewriter.typeString('Employee Scheduling')
// 			.pauseFor(1500)
// 			.deleteChars(10)
// 			.typeString('Engagement')
// 			.pauseFor(1500)
// 			.start();
// 	}

	/*========== j(window).on('resize', function()) ==========*/

	j(window).on('resize', function()
	{
		/*========== Reset mobile navigation ==========*/

		if(j('#navigation').length)
		{
			var viewport_width = j(window).width();
			if(viewport_width >= 800)
			{
				j('#navigation > #navigation__menu .content .element-mobile .hamburger').removeClass('active');
				j('#navigation > #navigation__mobile').removeClass('active');
			}
		}
	});

	/*========== j(window).on('scroll', function()) ==========*/

	// j(window).on('scroll', function();

	/*========== Naviation behavior ==========*/

	if(j('#navigation').length)
	{
		var nav = j('#navigation');
		var nav_menu = j(nav).find('#navigation__menu');
		var nav_submenu = j(nav).find('#navigation__submenu');
		var nav_mobile = j(nav).find('#navigation__mobile');

		j(nav_menu).find('ul li a').each(function()
		{
			var parent_li = j(this).parent('li');
			j(this).on('click', function()
			{
				var submenu = j(this).data('submenu');
				if(submenu !== undefined)
				{
					if(parent_li.hasClass('active'))
					{
						j(parent_li).removeClass('active');
						j('#navigation__submenu').find('.submenu').slideUp();
					}
					else
					{
						j(parent_li).addClass('active').siblings().removeClass('active');
						j('#navigation__submenu').find('.submenu[data-submenu="'+submenu+'"]').slideDown().siblings().slideUp();
					}
					return false;
				}
				else
				{
					return true;
				}
			});
		});

		j(nav_menu).find('.element-mobile').on('click', function()
		{
			var hamburger = j(this).find('.hamburger');
			j(hamburger).toggleClass('active');

			if(j(nav_mobile).hasClass('active'))
			{
				j(nav_mobile).addClass('inactive').removeClass('active');
			}
			else
			{
				j(nav_mobile).addClass('active').removeClass('inactive');
			}
		});

		j(nav_mobile).find('ul li a').each(function()
		{
			j(this).on('click', function()
			{
				if(j(this).parent().children('ul').length)
				{
					//j(this).find('span').addClass('active');
					//j(this).parent().siblings().find('span').removeClass('active');
					j(this).siblings('ul').slideDown();
					j(this).parent().siblings().find('ul').slideUp();
					return false;
				}
				else
				{
					return true;
				}
			});
		});
	}

	/*========== Inject full size background image ==========*/

	if(j('.bg-lazy').length)
	{
		j('.bg-lazy').each(function()
		{
			var background_full = j(this).data('background-full');
			j(this).css('background-image', 'url('+background_full+')');
			j(this).addClass('bg-loaded');
		});
	}

	/*========== Inject full size image source ==========*/

	if(j('.img-lazy').length)
	{
		j('.img-lazy').each(function()
		{
			var image_full = j(this).data('image-full');
			j(this).attr('src', image_full);
			j(this).addClass('img-loaded');
		});
	}

	/*========== Hero slideshow ==========*/

	if(j('.container-slideshow').length)
	{
		j('.container-slideshow').each(function()
		{
			var carousel = j(this);

			j(carousel).owlCarousel(
			{
				items: 1,
				mouseDrag: false,
				autoHeight: true,
				//onInitialized: setHeight,
				//onResized: setHeight,
				//onTranslated: setHeight
			});
			/*
			function setHeight(event)
			{
				var maxHeight = 0;
			    j(carousel).find('.owl-item').each(function()
			    {
			        var slideHeight = parseInt(j(this).height());
			        maxHeight = (maxHeight >= slideHeight ? maxHeight : slideHeight);
			    });
			    j(carousel).find('.owl-stage-outer').css('height', maxHeight);
			}
			*/
		});
	}

	/*========== Content carousel ==========*/

	if(j('.content-carousel').length)
	{
		j('.content-carousel').each(function()
		{
			var carousel = j(this);
			var carousel_id = j(this).data('carousel-id');
			var carousel_nav = j('.content-carousel-nav[data-carousel-id="'+carousel_id+'"]');

			var carouselLoop = j(carousel).data('loop');
			var carouselCenter = j(carousel).data('center');
			var carouselAutoplay = j(carousel).data('autoplay');
			var carouselAutoplayTimeout = j(carousel).data('autoplay-timeout');
			var carouselAutoplayPause = j(carousel).data('autoplay-pause');

			// Fix for "Cumulative Layout Shift"
			j(carousel).on('initialized.owl.carousel', function(event)
			{
				j(carousel).find('.owl-item').each(function()
				{
					var item = j(this);
					j(item).find('.box').each(function()
					{
						var box = j(this);
						j(box).removeClass('box-2');
						j(box).removeClass('box-3');
						j(box).removeClass('box-4');
						j(box).removeClass('box-6');
						j(box).removeClass('box-12');
					});
				});
			});

			if(j(carousel).hasClass('content-carousel-default'))
			{
				if(j(carousel).hasClass('content-carousel-default-6'))
				{
					j(carousel).owlCarousel(
					{
						items: 2,
						loop: carouselLoop,
						center: carouselCenter,
						autoplay: carouselAutoplay,
						autoplayTimeout: carouselAutoplayTimeout,
						autoplayHoverPause: carouselAutoplayPause,
						dots: false,
						nav: true,
						navContainer: carousel_nav,
						navText: ['<span>&#10094;</span>', '<span>&#10095;</span>'],
						mouseDrag: false,
						responsive: {
							0: {
								items: 1
							},
							400: {
								items: 2
							}
						}
					});
				}
				else if(j(carousel).hasClass('content-carousel-default-4'))
				{
					j(carousel).owlCarousel(
					{
						items: 3,
						loop: carouselLoop,
						center: carouselCenter,
						autoplay: carouselAutoplay,
						autoplayTimeout: carouselAutoplayTimeout,
						autoplayHoverPause: carouselAutoplayPause,
						dots: false,
						nav: true,
						navContainer: carousel_nav,
						navText: ['<span>&#10094;</span>', '<span>&#10095;</span>'],
						mouseDrag: false,
						responsive: {
							0: {
								items: 1
							},
							400: {
								items: 2
							},
							600: {
								items: 3
							}
						}
					});
				}
				else if(j(carousel).hasClass('content-carousel-default-3'))
				{
					j(carousel).owlCarousel(
					{
						items: 4,
						loop: carouselLoop,
						center: carouselCenter,
						autoplay: carouselAutoplay,
						autoplayTimeout: carouselAutoplayTimeout,
						autoplayHoverPause: carouselAutoplayPause,
						dots: false,
						nav: true,
						navContainer: carousel_nav,
						navText: ['<span>&#10094;</span>', '<span>&#10095;</span>'],
						mouseDrag: false,
						responsive: {
							0: {
								items: 1
							},
							400: {
								items: 2
							},
							600: {
								items: 3
							},
							800: {
								items: 4
							}
						}
					});
				}
			}
			else if(j(carousel).hasClass('content-carousel-extended'))
			{
				function fixActiveOverflow(event)
				{
					j(carousel).find('.owl-item:nth-of-type(7)').removeClass('active');
				}
				j(carousel).owlCarousel(
				{
					items: 6,
					loop: carouselLoop,
					center: carouselCenter,
					autoplay: carouselAutoplay,
					autoplayTimeout: carouselAutoplayTimeout,
					autoplayHoverPause: carouselAutoplayPause,
					dots: false,
					nav: true,
					navContainer: carousel_nav,
					navText: ['<span>&#10094;</span>', '<span>&#10095;</span>'],
					mouseDrag: false,
					onInitialized: fixActiveOverflow,
					responsive: {
						0: {
							items: 1
						},
						400: {
							items: 2
						},
						600: {
							items: 3
						},
						800: {
							items: 4
						},
						1000: {
							items: 5
						},
						1200: {
							items: 6
						}
					}
				});
			}
			else if(j(carousel).hasClass('content-carousel-single'))
			{
				j(carousel).owlCarousel(
				{
					items: 1,
					loop: true,
					center: carouselCenter,
					autoplay: carouselAutoplay,
					autoplayTimeout: carouselAutoplayTimeout,
					autoplayHoverPause: carouselAutoplayPause,
					dots: false,
					nav: true,
					navContainer: carousel_nav,
					navText: ['<span>&#10094;</span>', '<span>&#10095;</span>'],
					mouseDrag: false,
					stagePadding: 20
				});
			}
			else
			{
				j(carousel).owlCarousel(
				{
					items: 4,
					loop: carouselLoop,
					center: carouselCenter,
					autoplay: carouselAutoplay,
					autoplayTimeout: carouselAutoplayTimeout,
					autoplayHoverPause: carouselAutoplayPause,
					dots: false,
					nav: true,
					navContainer: carousel_nav,
					navText: ['<span>&#10094;</span>', '<span>&#10095;</span>'],
					mouseDrag: false,
					responsive: {
						0: {
							items: 1
						},
						400: {
							items: 2
						},
						600: {
							items: 3
						},
						800: {
							items: 4
						}
					}
				});
			}
		});
	}

	/*========== Engage(ment) carousel ==========*/

	if(j('.engagement-carousel').length)
	{
		j('.engagement-carousel').each(function()
		{
			var carousel = j(this);
			var carousel_id = j(this).data('carousel-id');
			var carousel_nav = j('.content-carousel-nav[data-carousel-id="'+carousel_id+'"]');

			// Fix for "Cumulative Layout Shift"
			j(carousel).on('initialized.owl.carousel', function(event)
			{
				j(carousel).find('.owl-item').each(function()
				{
					var item = j(this);
					j(item).find('.box').each(function()
					{
						var box = j(this);
						j(box).removeClass('box-4');
					});
				});
			});
			j(carousel).owlCarousel(
			{
				mouseDrag: false,
				dots: false,
				nav: true,
				navContainer: carousel_nav,
				navText: ['<span>&#10094;</span>', '<span>&#10095;</span>'],
				responsive: {
					0: {
						items: 1
					},
					400: {
						items: 2
					},
					600: {
						items: 3
					},
					900: {
						items: 2
					},
					1200: {
						items: 3
					}
				}
			});
		});
	}

	/*========== Timeline carousel ==========*/

	if(j('.timeline-carousel').length)
	{
		j('.timeline-carousel').each(function()
		{
			var carousel = j(this);
			var carousel_id = j(this).data('carousel-id');
			var carousel_nav = j('.content-carousel-nav[data-carousel-id="'+carousel_id+'"]');

			// Fix for "Cumulative Layout Shift"
			j(carousel).on('initialized.owl.carousel', function(event)
			{
				var milestone_tallest = 0;
				j(carousel).find('.owl-item').each(function()
				{
					var item = j(this);
					j(item).find('.box').each(function()
					{
						var box = j(this);
						j(box).removeClass('box-3');

						// Same height milestones
						j(box).find('.milestone').each(function()
						{
							var milestone = j(this);
							var milestone_content = j(milestone).find('.descriptions');
							var milestone_card = j(milestone_content).find('.description');
							var milestone_height = j(milestone_card).outerHeight();

							if(milestone_height > milestone_tallest)
							{
								milestone_tallest = milestone_height;
							}
						});
					});
				});
				j(carousel).find('.owl-item .box .milestone .descriptions').css('min-height', milestone_tallest+'px');
			});

			// Same height milestones (refreshed)
			j(carousel).on('refreshed.owl.carousel', function(event)
			{
				var milestone_tallest = 0;
				j(carousel).find('.owl-item').each(function()
				{
					var item = j(this);
					j(item).find('.box').each(function()
					{
						var box = j(this);

						j(box).find('.milestone').each(function()
						{
							var milestone = j(this);
							var milestone_content = j(milestone).find('.descriptions');
							var milestone_card = j(milestone_content).find('.description');
							var milestone_height = j(milestone_card).outerHeight();

							if(milestone_height > milestone_tallest)
							{
								milestone_tallest = milestone_height;
							}
						});
					});
				});
				j(carousel).find('.owl-item .box .milestone .descriptions').css('min-height', milestone_tallest+'px');
			});

			j(carousel).owlCarousel(
			{
				items: 4,
				slideBy: 'page',
				dots: false,
				nav: true,
				navContainer: carousel_nav,
				navText: ['<span>&#10094;</span>', '<span>&#10095;</span>'],
				mouseDrag: false,
				responsive: {
					0: {
						items: 1
					},
					540: {
						items: 2
					},
					860: {
						items: 3
					},
					1100: {
						items: 4
					}
				}
			});
		});
	}

	/*========== Continuous carousel ==========*/

	if(j('.continuous-carousel').length)
	{
		j('.continuous-carousel').each(function()
		{
			var carousel = j(this);

			j(carousel).trigger('destroy.owl.carousel');

			// Fix for "Cumulative Layout Shift"
			j(carousel).on('initialized.owl.carousel', function(event)
			{
				j(carousel).find('.owl-item').each(function()
				{
					var item = j(this);
					j(item).find('.box').each(function()
					{
						var box = j(this);
						j(box).removeClass('box-2');
						j(box).removeClass('box-3');
						j(box).removeClass('box-4');
						j(box).removeClass('box-6');
						j(box).removeClass('box-12');
					});
				});
			});

			function fixActiveOverflow(event)
			{
				j(carousel).find('.owl-item:nth-of-type(7)').removeClass('active');
			}

			j(carousel).owlCarousel(
			{
				startPosition: 1,
				items: 6,
				slideTransition: 'linear',
				loop: true,
				center: true,
				autoplay: true,
				autoplayTimeout: 2500,
				autoplaySpeed: 2500,
				dots: false,
				nav: false,
				autoplayHoverPause: true,
				mouseDrag: false,
				onInitialized: fixActiveOverflow,
				responsive: {
					0: {
						items: 1
					},
					400: {
						items: 2
					},
					600: {
						items: 3
					},
					800: {
						items: 4
					},
					1000: {
						items: 5
					},
					1200: {
						items: 6
					}
				}
			});

			j(carousel).trigger('refresh.owl.carousel');
		});
	}

	/*========== Wistia video embed ==========*/

	if(j('.video').length)
	{
		j('.video').each(function()
		{
			j(this).on('click', function()
			{
				if(j(this).hasClass('video-inline'))
				{
					j(this).addClass('active');
					var iframe = j(this).find('iframe');
					var iframe_src = j(iframe).data('iframe-src');
					j(iframe).attr('src', iframe_src+'&autoplay=1&loop=1&autopause=0&background=0');
					return false;
				}
			});
		});
	}

	/*========== Tabs ==========*/

	if(j('.container-js-tabs').length)
	{
		j('.container-js-tabs').each(function()
		{
			var tabs_container = j(this);
			var tabs_hor = j(tabs_container).find('article.tabs-horizontal');
			var tabs_ver = j(tabs_container).find('article.tabs-vertical');

			// horizontal
			var hor_sidebar = j(tabs_hor).find('.box-sidebar');
			var hor_content = j(tabs_hor).find('.box-content');

			j(hor_sidebar).find('ul > li').each(function()
			{
				j(this).on('click', function()
				{
					var tab_id = j(this).data('tab-id');
					j(this).addClass('selected').siblings().removeClass('selected');
					j(hor_content).find('article[data-tab-id="'+tab_id+'"]').addClass('active').siblings().removeClass('active');
				});
			});

			// vertical
			j(tabs_ver).find('.content > article').each(function()
			{
				j(this).on('click', function()
				{
					j(this).addClass('selected').siblings().removeClass('selected');
				});
			});
		});
	}

	/*========== FAQs ==========*/

	if(j('.element-faqs').length)
	{
		j('.element-faqs').each(function()
		{
			var parent = j(this).find('ul, ol');
			var child = j(parent).find('li');

			j(child).has('ul').each(function(i)
			{
				var count = i+1;
				j(this).addClass('item-'+count);
				if(count === 1)
				{
					j(this).addClass('item-active');
				}
				j(this).find('strong').on('click', function()
				{
					j(this).parent('li').addClass('item-active');
					j(this).parent('li').siblings('li').removeClass('item-active');
				});
			});
		});
	}

	/*========== Lightbox / URL query trigger ==========*/

	var uri = window.location.toString();
	if(uri.indexOf('?action=lightbox') > 0)
	{
		function queryValue()
		{
		    var vars = [], hash;
		    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
		    for(var i = 0; i < hashes.length; i++)
		    {
		        hash = hashes[i].split('=');
		        vars.push(hash[0]);
		        vars[hash[0]] = hash[1];
		    }
		    return vars;
		}
		if(uri.indexOf('&response=video') > 0)
		{
			if(queryValue()['vid'] != undefined)
			{
				var videoID = queryValue()['vid'];
				var lightboxVideo = j('.container-lightbox-video');

				j(lightboxVideo).each(function()
				{
					if(j(this).data('lightbox-id') === videoID)
					{
						j(this).addClass('active');
						videoDiv = j(this).find('.video');
						videoEmbed = j(videoDiv).find('iframe');
						videoEmbedSrc = j(videoEmbed).data('iframe-src');
						j(videoEmbed).attr('src', videoEmbedSrc);
					}
				});
			}
		}
		if(uri.indexOf('&response=form') > 0)
		{
			if(queryValue()['fid'] != undefined)
			{
				var form_id = queryValue()['fid'];
				var lightbox_form = j('.container-lightbox[data-lightbox-id="'+form_id+'"]');
				j(lightbox_form).addClass('active').removeClass('inactive');
			}
		}
	}

	/*========== Lightbox Trigger ==========*/

	if(j('.trigger-lightbox').length)
	{
		// init
		j('.trigger-lightbox').each(function()
		{
			j(this).on('click', function()
			{
				var lightbox_id = j(this).data('lightbox-id');
				var lightbox = j('.container-lightbox[data-lightbox-id="'+lightbox_id+'"]');
				j(lightbox).addClass('active').removeClass('inactive');

				if(j(this).hasClass('trigger-lightbox-video'))
				{
					var iframe = j(lightbox).find('iframe');
					var iframe_src = j(iframe).data('iframe-src');
					j(iframe).attr('src', iframe_src+'&autoplay=1&loop=1&autopause=0&background=0');

					var elem = document.getElementsByTagName('iframe');
					if (elem.requestFullscreen) {
					  elem.requestFullscreen();
					}
				}
				return false;
			});
		});
		// terminate
		if(j('.icon').length)
		{
			j('.icon').each(function()
			{
				j(this).on('click', function()
				{
					var lightbox_parent = j(this).parent('.container-lightbox');
					j(lightbox_parent).addClass('inactive').removeClass('active');

					if(j(lightbox_parent).hasClass('container-lightbox-video'))
					{
						var iframe = j(lightbox_parent).find('iframe');
						j(iframe).attr('src', null);
					}
				});
			});
		}
		if(j('.close').length)
		{
			j('.close').each(function()
			{
				j(this).on('click', function()
				{
					var lightbox_parent = j(this).parents('.container-lightbox');
					j(lightbox_parent).addClass('inactive').removeClass('active');

					if(j(lightbox_parent).hasClass('container-lightbox-video'))
					{
						var iframe = j(lightbox_parent).find('iframe');
						j(iframe).attr('src', null);
					}
				});
			});
		}
	}

	/*========== Resources ==========*/

	if(j('#template__resources').length)
	{
		var filters = j('#filters');
		var type = j(filters).find('select[name="_t"]');
		var solution = j(filters).find('select[name="_s"]');
		var product = j(filters).find('select[name="_p"]');
		var industry = j(filters).find('select[name="_i"]');

		j(type).on('change', function()
		{
			var selection = j(this).find(':selected').text();
			if(selection === 'Articles' || selection === 'Press Releases')
			{
				j('input[name="_c"]').attr('disabled', false);
				if(selection === 'Articles')
				{
					j('input[name="_c"]').val('article');
				}
				else if(selection === 'Press Releases')
				{
					j('input[name="_c"]').val('press-release');
				}
			}
			else
			{
				j('input[name="_c"]').attr('disabled', true);
			}
		});
		j(filters).submit(function()
		{
			if(j(type).find(':selected').val() === '')
			{
				j(type).attr('disabled', true);
			}
			if(j(solution).find(':selected').val() === '')
			{
				j(solution).attr('disabled', true);
			}
			if(j(product).find(':selected').val() === '')
			{
				j(product).attr('disabled', true);
			}
			if(j(industry).find(':selected').val() === '')
			{
				j(industry).attr('disabled', true);
			}
		});
	}

	/*========== Responsive Table ==========*/

	if(j('table.responsive').length)
	{
		j('table.responsive').each(function()
		{
			var table = j(this);

			var thead = j(table).find('thead');
			var thead_tr = j(thead).find('tr');
			var thead_th = j(thead_tr).find('th, td');

			var tbody = j(table).find('tbody');
			var tbody_tr = j(tbody).find('tr');

			j(tbody_tr).each(function()
			{
				if(j(table).hasClass('responsive-horz'))
				{
					var tbody_td = j(this).find('td');
				}
				else if(j(table).hasClass('responsive-vert'))
				{
					var tbody_td = j(this).find('td:not(:first-child)');
				}
				j(tbody_td).each(function(index)
				{
					if(j(table).hasClass('responsive-horz'))
					{
						var count = index+1;
					}
					else if(j(table).hasClass('responsive-vert'))
					{
						var count = index+2;
					}
					var column = j(thead_tr).find('td:nth-child('+count+'), th:nth-child('+count+')').text();

					if(j(this).find('.icon').length)
					{
						j(this).html('<label data-text="'+column+'"><dfn>'+j(this).html()+'</dfn></label>');
					}
					else if(j(this).find('.trigger-lightbox').length)
					{
						j(this).wrapInner('<label data-text="'+column+'"><dfn></dfn></label>');
					}
					else
					{
						j(this).html('<label data-text="'+column+'"><dfn>'+j(this).html()+'</dfn></label>');
					}
				});
			});
		});
	}

	/*========== UX: Region Notice ==========*/

	if(j('#ux__region-notice').length)
	{
		var uxrn_close_btn = j('#ux__region-notice').find('#uxrn_close_btn');
		var uxrn_close_icn = j('#ux__region-notice').find('#uxrn_close_icn');
		j(uxrn_close_btn).on('click', function()
		{
			j('#ux__region-notice').hide();
			return false;
		});
		j(uxrn_close_icn).on('click', function()
		{
			j('#ux__region-notice').hide();
		});
	}

	/*========== Element: Marquee ==========*/

	if(j('.element-marquee').length)
	{
		j('.element-marquee').each(function()
		{
			var marquee = j(this);
			var marquee_wrds = j(this).find('.words');
			var words_str = j(this).find('.words').data('words');
			var words_arr = words_str.split(', ');
			var data_delay = j(this).find('.words').data('delay');
			var i = 0;

			function marquee_getLabel()
			{
				i = (i + 1) % words_arr.length;
				//console.log(words_arr[i]);
				//console.log(i);
				var words_curr = j(marquee).find('.words').text();
				return j(marquee).text().replace(words_curr, words_arr[i]);
			}
			function marquee_changeLabel()
			{
				var label = marquee_getLabel();
				//console.log(label);
				j(marquee_wrds).text(label);
			}
			setInterval(marquee_changeLabel, data_delay);
		});
	}

	/*========== Template: ResOps / Navigation ==========*/

	if(j('#template__grdfrmwrk').length)
	{
		if(j('#grdfrmwrk_navigation').length)
		{
			var navigation = j('#grdfrmwrk_navigation');
			var menu = j(navigation).find('[data-role="menu"]');
			var hamburger = j(navigation).find('[data-role="hamburger"]');
			var submenu = j(navigation).find('[data-role="submenu"]');
			var mobile = j(navigation).find('[data-role="mobile"]');
			j(menu).find('li > a').each(function()
			{
				j(this).on('mouseenter focus', function()
				{
					if(j(this).attr('role') === 'link')
					{
						var submenu = j(this).data('submenu');
						//console.log(submenu);
						j('#grdfrmwrk_navigation').find('[data-role="submenu"]').hide();
						j('#grdfrmwrk_navigation').find('[data-role="submenu"][data-submenu="'+submenu+'"]').show();
					}
					else
					{
						j('#grdfrmwrk_navigation').find('[data-role="submenu"]').hide();
					}
					j(this).parent().addClass('active');
					j(this).parent().siblings().removeClass('active');
				});
			});
			j(navigation).on('mouseleave', function()
			{
				j(menu).find('li').removeClass('active');
				j(submenu).hide();
			});
			j(hamburger).find('ul[role="menu"]').on('click', function()
			{
				j(this).addClass('active');
				j(mobile).show();
			});
		}
	}

	/*========== Template: ResOps / Module: Explorer ==========*/

	if(j('[data-module="explorer"]').length)
	{
		j('[data-module="explorer"]').each(function()
		{
			var xplr = j(this);
			var xplr_n = j(this).find('.column[data-role="navigation"]');
			var xplr_c = j(this).find('.column[data-role="content"]');

			j(xplr_n).find('.trigger').each(function()
			{
				j(this).on('mouseover focus', function()
				{
					var xplr_t = j(this).data('target');
					j(this).addClass('active').siblings().removeClass('active');
					j(xplr_c).find('.target[data-target="'+xplr_t+'"]').show().siblings().hide();
				});
			});
		});
	}

	/*========== Template: ResOps / Waypoints ==========*/

	if(j('#template__grdfrmwrk').length)
	{
		j('#template__grdfrmwrk').find('section.container[data-action="fadein"]').each(function()
		{
			var containerID = j(this).attr('id');
			j('#'+containerID).waypoint(
			{
				handler: function(direction)
				{
					j('#'+containerID).addClass('container-visible');
				},
				offset: '70%'
			});
		});
	}

	if(j('[data-action="visibility"]').length)
	{
		j('[data-action="visibility"]').each(function()
		{
			var el = j(this);
			var el_offset = j(el).data('offset');
			j(el).waypoint(
			{
				handler: function(direction)
				{
					j(el).addClass('visible');
				},
				offset: el_offset
			});
		});
	}

	/*========== Template: ResOps / Lightboxes ==========*/

	if(j('#template__grdfrmwrk').length)
	{
		j('#template__grdfrmwrk').find('a[data-action="lightbox"]').each(function()
		{
			j(this).on('click', function()
			{
				var lb_target = j(this).data('lightbox');
				var lb_container = j('#template__grdfrmwrk').find('[data-role="lightbox"]#popup_'+lb_target);
				j(lb_container).addClass('container-active').find('[data-role="popup"]').addClass('container-active');
				return false;
			});
		});
		var lb_terminate = j('#template__grdfrmwrk').find('[data-role="close"]');
		j(lb_terminate).on('click', function()
		{
			j('#template__grdfrmwrk').find('[data-role="lightbox"]').removeClass('container-active');
			j('#template__grdfrmwrk').find('[data-role="popup"]').removeClass('container-active');
		});
		j(document).keydown(function(e)
		{
			if(e.keyCode === 27)
			{
				j('#template__grdfrmwrk').find('[data-role="lightbox"]').removeClass('container-active');
				j('#template__grdfrmwrk').find('[data-role="popup"]').removeClass('container-active');
			}
		});
	}

	/*========== Template: ResOps / FAQs ==========*/

	if(j('#resops_faqs').length)
	{
		j('#resops_faqs').find('details').each(function()
		{
			j(this).on('click', function()
			{
				j(this).siblings().removeAttr('open');
			});
		});
	}

	/*========== Template: ResOps / Smooth Scroll ==========*/

	if(j('#template__grdfrmwrk').length)
	{
		document.querySelectorAll('a[href^="#"]').forEach(anchor => {
			anchor.addEventListener('click', function (e) {
				e.preventDefault();

				document.querySelector(this.getAttribute('href')).scrollIntoView({
					behavior: 'smooth'
				});
			});
		});
	}

});























